/* eslint-disable react-hooks/exhaustive-deps */
import {
	Divider,
	FormControl,
	FormLabel,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	Icon,
	ModalOverlay,
	Progress,
	Text,
	Center,
} from '@chakra-ui/react'
import Select from '../chakra-react-select'
import React, { useState, useEffect } from 'react'
import { useLoadActivityListV1 } from '../../hooks/activity.hooks'
import { useAddParentActivity } from '../../hooks/activity.hooks'
import { useLanguageContext } from '../../context/locale.context'
import ButtonCTA from './../globalComponents/button/index'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import {
	GA_CATEGORY_DIALOG_BOX,
	sectionDetailedTrack,
} from '../../containers/repository/repo.utils'

const customStyles = {
	placeholder: styles => {
		return {
			...styles,

			color: '#303030',
		}
	},
	container: styles => {
		return {
			...styles,
			background: 'white',
		}
	},
}

const SelectParentAcitivity = ({ isOpen, onClose, activity, loadDetails }) => {
	const [isError, setisError] = useState(false)
	const [orderFlag, setOrderFlag] = useState(null)
	const [successMessage, setSuccessMessage] = useState(false)
	const { mutate, isLoading } = useLoadActivityListV1()
	const [options, setOptions] = useState([])
	const { mutate: mutateAddparentActivity } = useAddParentActivity()
	const [selectedValue, setSelectedValue] = useState(0)
	const {
		state: { locale },
	} = useLanguageContext()
	useEffect(() => {
		mutate(
			{
				flag: 0,
				is_active: 0,
				is_due: 0,
				is_search: 0,
				is_unread: 0,
				limit_value: 30,
				page_limit: 30,
				page_start: 0,
				queue_id: 0,
				search_string: '',
				sort_flag: 4,
				start_from: 0,
				status_type_id: 0,
			},
			{
				onSuccess: res => {
					let data = res.list.map(
						({
							activity_cuid_1,
							activity_cuid_2,
							activity_cuid_3,
							activity_id,
							activity_title,
							operating_asset_first_name,
							activity_type_category_id,
							activity_type_id,
						}) => ({
							details: {
								activity_cuid_1,
								activity_cuid_2,
								activity_cuid_3,
								operating_asset_first_name,
								activity_id,
								activity_type_category_id,
								activity_type_id,
							},
							label: activity_title,
							value: `${
								activity_id +
								'|' +
								activity_title +
								'|' +
								activity_type_category_id
							}`,
						})
					)

					setOptions([...data])
				},
				onError: async error => {
					setisError(true)
				},
			}
		)
	}, [])

	const setParentAcitivity = () => {
		if (!!orderFlag) {
			mutateAddparentActivity(
				{
					activity_id: activity.activity_id,
					parent_activity_id: orderFlag.details.activity_id,
				},
				{
					onSuccess: () => {
						setOrderFlag(null)
						setSuccessMessage(true)
						// loadDetails(activity)
					},
				}
			)
		}
		// onClose()
	}

	const closeModal = () => {
		loadDetails(activity)
		setSuccessMessage(false)
		onClose()
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={closeModal}
			closeOnOverlayClick={false}
			isCentered
			variant='activityMenuModal'
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{locale['Set Parent Activity']}</ModalHeader>
				<ModalCloseButton />
				<Divider />
				{successMessage ? (
					<ModalBody py='2.3rem'>
						<Center flexDirection='column'>
							<Icon
								as={AiOutlineCheckCircle}
								w='50px'
								h='50px'
								color='brand.700'
							/>
							<Text color='brand.700' fontSize='1rem'>
								Success
							</Text>
						</Center>
					</ModalBody>
				) : (
					<>
						<ModalBody>
							{!isLoading && (
								<FormControl id='selectType'>
									<FormLabel
										fontWeight='500'
										fontSize='0.875rem'
										color='gray.400'
									>
										{locale['Select Activity']}
									</FormLabel>
									<Select
										size='sm'
										placeholder={locale['Select...']}
										options={options
											.filter(
												item =>
													item.details.activity_type_category_id ===
														activity.activity_type_category_id &&
													item.label !== activity.activity_title
											)
											.filter(Boolean)}
										value={orderFlag}
										onChange={e => {
											setOrderFlag(e)
										}}
										styles={customStyles}
									/>
								</FormControl>
							)}
							{isLoading && (
								<Progress
									colorScheme='green'
									my={5}
									size='md'
									isIndeterminate
								/>
							)}
							{isError && (
								<Text color='red'>
									{locale['Something went wrong please try again!']}
								</Text>
							)}
						</ModalBody>
						<ModalFooter>
							<ButtonCTA
								variant='modalCloseButton'
								mr='1rem'
								onClick={() => {
									sectionDetailedTrack({
										category: GA_CATEGORY_DIALOG_BOX,
										action: 'Select Parent Activity',
										label: 'Close Modal',
									})
									onClose()
								}}
							>
								{locale['Close']}
							</ButtonCTA>
							{!isError && (
								<ButtonCTA
									variant='modalSubmitButton'
									isLoading={isLoading}
									onClick={() => {
										sectionDetailedTrack({
											category: GA_CATEGORY_DIALOG_BOX,
											action: 'Select Parent Activity',
											label: 'Set Parent Activity',
										})
										setParentAcitivity()
									}}
								>
									{locale['Set']}
								</ButtonCTA>
							)}
						</ModalFooter>
					</>
				)}
			</ModalContent>
		</Modal>
	)
}
export default SelectParentAcitivity
